import cookie from 'react-cookie';
import { TODAY } from 'constants/constants';
import { LINKEDIN_PROMO_CODES } from 'constants/promoCodes';

/**
 * LinkedIn promotional code helper functions
 * Manages time-based promo codes for LinkedIn campaign users
 */

/**
 * Check if user is from LinkedIn traffic
 * @returns {boolean}
 */
export const isLinkedInUser = () => {
  const utmCampaignCookie = cookie.load('utm_campaign');
  return utmCampaignCookie === 'linkedin_job';
};

/**
 * Get the current active LinkedIn promo code based on date
 * @param {Date} currentDate - The date to check (defaults to TODAY)
 * @returns {Object|null} - Active promo code object or null if none active
 */
export const getActiveLinkedInPromoCode = (currentDate = TODAY) => {
  // Find the first promo code where:
  // - startDate is null or currentDate >= startDate
  // - currentDate < endDate
  const activeCode = LINKEDIN_PROMO_CODES.find((promo) => {
    const isAfterStart = !promo.startDate || currentDate >= promo.startDate;
    const isBeforeEnd = currentDate < promo.endDate;
    return isAfterStart && isBeforeEnd;
  });

  return activeCode || null;
};

/**
 * Get the promo code string for LinkedIn users
 * @returns {string|null} - The current promo code or null if none active
 */
export const getLinkedInPromoCode = () => {
  const activePromo = getActiveLinkedInPromoCode();
  return activePromo ? activePromo.code : null;
};

/**
 * Check if LinkedIn promo code is currently active
 * @returns {boolean}
 */
export const isLinkedInPromoActive = () => {
  return getActiveLinkedInPromoCode() !== null;
};

/**
 * Get formatted message for LinkedIn promo banner
 * @returns {string} - Formatted banner message with current code
 */
export const getLinkedInPromoMessage = () => {
  const promoCode = getLinkedInPromoCode();
  if (!promoCode) {
    return '';
  }
  return `Use code ${promoCode} for 1 free month of Twine Pro`;
};
